import { useState } from "react";
import I18n from "common/i18n";
import Constants from "common/constant";
import { btnDelay, usePlaySound } from "common/utils";
import { PieceListContext } from "features/builder/pieceList";
import { MyMapsTab } from "./MyMapsTab";
import { TrashMapsTab } from "./TrashMapsTab";
import { PublicMapsTab } from "./PublicMapsTab";

const TAB_ITEMS: {
  tab: PieceListContext;
  labelKey: string;
  activeBg: string;
  edgeBg: string;
}[] = [
  {
    tab: PieceListContext.MINE,
    labelKey: "MSG_BUILDER_TAB_MY_MAPS",
    activeBg: "bg-orange-100",
    edgeBg: "bg-[#E1AD60]",
  },
  {
    tab: PieceListContext.PUBLIC,
    labelKey: "MSG_BUILDER_TAB_PUBLIC_MAPS",
    activeBg: "bg-blue-100",
    edgeBg: "bg-[#9BBFD4]",
  },
  {
    tab: PieceListContext.TRASH,
    labelKey: "MSG_BUILDER_TAB_TRASH",
    activeBg: "bg-brown-80",
    edgeBg: "bg-brown-60",
  },
];

const TAB_BAR_WIDTH = 56;
// スクリーン高 566px に 3タブ + gap-3(12)×2 が収まるよう 160（160×3+24=504）
const TAB_HEIGHT = 160;

export const PieceBuilderTopPage = () => {
  const play = usePlaySound();
  const [activeTab, setActiveTab] = useState<PieceListContext>(PieceListContext.MINE);

  const handleSelectTab = (tab: PieceListContext) => () => {
    if (tab === activeTab) return;
    play();
    btnDelay(() => setActiveTab(tab));
  };

  return (
    <div className="flex-col-el relative w-full h-full overflow-hidden">
      <img
        alt="ゲームの背景"
        src={`${Constants.assetHost}/assets/images/bg_course_builder_scene.webp`}
        className="absolute top-0 left-0 w-full h-full object-cover"
      />

      <div
        className="flex-col-el flex-1 w-full h-full relative"
        style={{ paddingRight: TAB_BAR_WIDTH }}
      >
        {activeTab === PieceListContext.MINE && <MyMapsTab />}
        {activeTab === PieceListContext.PUBLIC && <PublicMapsTab />}
        {activeTab === PieceListContext.TRASH && <TrashMapsTab />}
      </div>

      <div
        className="flex-col-el justify-center items-end absolute right-0 top-0 h-full gap-3 pointer-events-none"
        style={{ width: TAB_BAR_WIDTH }}
      >
        {TAB_ITEMS.map(({ tab, labelKey, activeBg, edgeBg }) => {
          const isActive = activeTab === tab;
          return (
            <div
              key={tab}
              className="relative shrink-0"
              style={{ width: TAB_BAR_WIDTH, height: TAB_HEIGHT }}
            >
              <div
                className={`flex-col-el absolute top-0 right-0 w-full h-full rounded-tl-3xl rounded-bl-3xl ${
                  isActive ? edgeBg : "bg-gray2-60"
                }`}
              />
              <button
                type="button"
                onClick={handleSelectTab(tab)}
                style={{
                  width: TAB_BAR_WIDTH,
                  height: TAB_HEIGHT - 8,
                }}
                className={`type-inherit-font flex-col-el shrink-0 items-center justify-center relative rounded-l-3xl py-4 cursor-pointer pointer-events-auto overflow-hidden border-0 ${
                  isActive ? `${activeBg} z-10` : "bg-gray2-100"
                }`}
              >
                <p className="type-text type-sm text-white text-center [writing-mode:vertical-rl]">
                  {I18n.t(labelKey)}
                </p>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
